<template>
  <Root />
</template>

<script setup lang="ts">
import { computed, h, useAttrs, type VNode, watchEffect } from 'vue'

import { highlightChunks, type Query } from './highlightChunks.ts'

interface Props {
  text: string
  queries?: Query
  caseSensitive?: boolean
  wholeWordMatch?: boolean
  highlightStyle?: any
  highlightClass?: any
  highlightComponent?: any
}

const props = withDefaults(defineProps<Props>(), {
  queries: '',
  highlightStyle: '',
  highlightClass: '',
  highlightComponent: 'mark',
})

const attrs = useAttrs()

const highlights = computed(() => highlightChunks(props.text, props.queries, props))

function render() {
  const children: (VNode | string)[] = []

  for (const { text, isHighlighted, highlightIndex } of highlights.value) {
    if (!isHighlighted) {
      children.push(text)
      continue
    }

    const child = h(
      props.highlightComponent,
      {
        class: ['v-text-highlight__mark', props.highlightClass],
        style: props.highlightStyle,
        key: highlightIndex,
        index: highlightIndex,
        text,
        ...attrs,
      },
      {
        default: () => text,
      },
    )

    children.push(child)
  }

  return h(
    'span',
    {
      class: 'v-text-highlight',
    },
    {
      default() {
        return children
      },
    },
  )
}

let Root: any = undefined

watchEffect(() => (Root = render()))
</script>

<style>
.v-text-highlight__mark {
  background-color: #f8cc46;
  border-radius: var(--border-radius);
  padding: 0 3px;
  text-decoration: inherit;
}
</style>
